export class RefreshTokenReuseError extends Error {
  public constructor() {
    super('Refresh token was already used elsewhere');
    this.name = 'RefreshTokenReuseError';
  }
}
